import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { IQuery, IQueryMyPlans } from "../../interfaces/IQuery";
import {
  IMyPlans,
  IResponseHistoryPlans,
  IResponseMyPlans,
} from "../../interfaces/MyPlans";

export const getMyPlans = async (
  { status }: IQueryMyPlans,
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();
  if (!!status) params.append("status", status);

  const { data } = await api.get<IResponseMyPlans>("/web/plan/my-plans", {
    signal,
    params,
  });

  return data;
};

export const useMyPlans = (params: IQueryMyPlans) => {
  const { status, enabled = true } = params;

  return useQuery({
    queryKey: ["MyPlans", status],
    queryFn: ({ signal }) => getMyPlans(params, signal),
    enabled: enabled,
    keepPreviousData: true,
  });
};

export const getMyPlansById = async (
  { id }: { id: string | undefined },
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();

  const { data } = await api.get<IMyPlans>(`/web/plan/my-plans/${id}`, {
    signal,
    params,
  });

  return data;
};

export const useMyPlansById = ({ id }: { id: string | undefined }) => {
  return useQuery({
    queryKey: ["MyPlans", id],
    queryFn: ({ signal }) => getMyPlansById({ id: id }, signal),
    enabled: !!id,
    keepPreviousData: false,
  });
};

export const getMyHistoryPlans = async (
  { page, pageSize, id }: IQuery,
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();

  if (!!page) params.append("page", page.toString());
  if (!!pageSize) params.append("pageSize", pageSize.toString());

  const { data } = await api.get<IResponseHistoryPlans>(
    `/web/plan/my-plans/${id}/history`,
    {
      signal,
      params,
    }
  );

  return data;
};

export const useMyHistoryPlans = (params: IQuery) => {
  const { page, pageSize, id } = params;

  return useQuery(
    ["MyHistoryPlans", id, page, pageSize],
    ({ signal }) => getMyHistoryPlans(params, signal),
    { enabled: !!id }
  );
};

export interface IPostCancelHistoryPlans {
  id: number;
  idHistory: number;
}

export const postCancelHistoryPlans = async ({
  id,
  idHistory,
}: IPostCancelHistoryPlans) => {
  const response = await api.post(
    `/web/plan/my-plans/${id}/history/${idHistory}/cancel`
  );
  return response;
};

export const postAcceptanceTerms = async (id: number) => {
  const response = await api.post(`/web/plan/my-plans/${id}/acceptance-terms`);
  return response;
};

export const postCancelPlan = async (id: number) => {
  const response = await api.post(`/web/plan/my-plans/${id}/cancel`);
  return response;
};
export interface IPostConfigurationPlan {
  id: number;
  configs: {
    is_machine_running?: boolean;
    broker_integration_id?: number | string;
    qty?: number;
    is_inverse_side?: boolean | null;
    is_algorithm_running?: boolean | null;
  };
}

export const postConfigurationPlan = async ({
  id,
  configs,
}: IPostConfigurationPlan) => {
  const response = await api.post(
    `/web/plan/my-plans/${id}/configuration`,
    configs
  );
  return response;
};
